module.exports = __webpack_public_path__ + "static/img/1uav4.bc72d52e.png";